import React, { useState, useEffect } from 'react';
import './Reset.password.scss';
import InputPassword from '../forms/inputs/Input.password'

import Button from '../forms/buttons/Button';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import GraphQlClient from '../services/graphql';
import { useTranslation } from 'react-i18next';
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";
import {useParams} from "react-router-dom";


function ActivateAccountComponent({ toaster, match, setUser }) {
     let { token } = useParams();
    const [newPassword, _setPassword] = useState('');
    const [newPasswordConfirm, _setPasswordConfirm] = useState('');
    const { t } = useTranslation(['auth']);

    const [validating, setValidating] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isUsedPassword,setIsUsedPassword] = useState(false);

    const [validateToken] = useMutation(gqlSchemaLibrary.auth.mutation.validateResetToken, {
        onCompleted: ({ validateResetToken }) => {
            console.log('validateResetToken: ', validateResetToken);
            if (validateResetToken) {
                AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'validate', action: 'validate token success', token: token});
                setValidated(!!validateResetToken.email);
            } else {
                AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'validate', action: 'validate token error', value: token});
                setValidated(!!validateResetToken);
            }
            setValidating(false);
        },
        onError: (error) => {
            AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'validate', action: 'validate token error', value: token});
        }
    });
    const [newPasswordSet] = useMutation(gqlSchemaLibrary.auth.mutation.newPasswordSet, {
        onCompleted: ({ newPasswordSet }) => {
            if(newPasswordSet.isUsed){
                AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'OnSubmit', action: 'save new password error'});
                setIsUsedPassword(true)
            }
            else{
                AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'OnSubmit', action: 'save new password success'});
                setIsUsedPassword(false)
                GraphQlClient.login(newPasswordSet.user.email, newPassword)
                    .then(meUser => {
                        setUser(meUser);
                    })
            }
        },
        onError: (error) => {
            AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'OnSubmit', action: 'save new password error'});
        }
    });

    useEffect(() => {
        console.log('token: ', token);
        setValidating(true);
        validateToken({
            variables: {
                resetToken: token
            }
        })
    }, [token, validateToken])

    const submitReset = (e) => {
        e.preventDefault();
        AuditTrail.sendLog(PAGES.ACTIVATE_ACCOUNT, {event: 'onClick', action: 'button save new password'});
        if (!newPassword || !newPasswordConfirm || !(newPasswordConfirm === newPassword)) {
            return;
        }
        newPasswordSet({
            variables: {
                resetToken: token,
                newpassword: newPassword
            }
        })
    }

    const setPassword = (value) => {
        _setPassword(value);

    }
    const setPasswordConfirm = (value) => {
        _setPasswordConfirm(value);
    }

    return (
        <div id="ResetPassword">
            <form onSubmit={submitReset}>
                <div className="_title">
                    <h1>
                        {validating ? t('check-token') : (validated ? t('welcome') : t('invalid-token'))}
                    </h1>
                </div>
                {
                    validating ?
                        <p className="_sent">

                        </p>
                        : (
                            !validated ?
                                <p className="_sent">
                                    <b>{t('text-invalid-token')}</b>
                                    <br />
                                    {t('detail-invalid-token')}

                                </p>
                                :
                                <>
                                <p>
                                    {t('set-password')}
                                    <br/>
                                    {(isUsedPassword) ? t('password-used'): <span></span> }
                                </p>
                                    <InputPassword
                                        label={t('pwd')}
                                        autocomplete="new-password"
                                        value={newPassword}
                                        onChange={setPassword}
                                        event={PAGES.ACTIVATE_ACCOUNT}
                                    />
                                    <InputPassword
                                        label={t('confirm-pwd')}
                                        autocomplete="new-password"
                                        value={newPasswordConfirm}
                                        onChange={setPasswordConfirm}
                                        event={PAGES.ACTIVATE_ACCOUNT}
                                    />
                                    <Button type={'submit'} disabled={!newPassword || !newPasswordConfirm || !(newPasswordConfirm === newPassword)}>
                                        <span>{t('confirm-pwd')}</span>
                                    </Button>
                                </>)
                }

            </form>
        </div>
    )
}

export default PageViewLog(ActivateAccountComponent);
